export default "__VITE_ASSET__CjAzCU4D__"